import React from 'react';


export const DeactivateOnRestartDocs = <p>When a tradePlan restarts, deactivate the trade plan. A button will appear that will
    allow you to activate the trade plan when you feel ready</p>;
export const MaxLossDocs = <p>If a repeating trade plan exceeds this loss, the trade plan will terminate</p>;
export const MaxAttemptsDocs = <p>Once a repeating trade plan has run this many times, it will terminate</p>;
export const MaxMinutesDocs = <p>Once a repeating trade plan has run for this many minutes, it will terminate. Please note that
    this is
    evaluated at the close of a position for that trade plan. Therefore, if this value is set for 15, and a position is
    closed 13 minutes into the trade plan&aposs existence, it will still run once more. </p>;